import React from 'react';
import { CheckIcon, GlobeIcon, LockIcon } from 'lucide-react';
import { Section, SectionTitle } from './Section';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { valueRows } from '../../data/content';
const perks = ['Instant Access', 'One-Time Payment', 'Lifetime Access', '7-Day Money-Back Guarantee'];
export function Offer() {
  return <Section tone="cream" id="offer" data-id="element-193" data-mp="3a4xcvjlccuhe">
      <SectionTitle eyebrow="Your offer" data-id="element-194" data-mp="3f4jq3t166aq7">
        Here's Everything You're Getting Today
      </SectionTitle>

      <ul className="mt-7 overflow-hidden rounded-3xl border border-navy/10 bg-white" data-id="element-195" data-mp="3juqepsvolv8g">
        {valueRows.map(row => <li key={row.label} className="flex items-start justify-between gap-4 border-b border-navy/10 px-4 py-3.5 last:border-b-0" data-id="element-196" data-mp="3nvshgjot4pf6">
            <span className="flex items-start gap-2 text-[14px] font-medium leading-snug text-navy/85" data-id="element-197" data-mp="1pdoaxvm808o">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-dark" data-id="element-198" data-mp="1klzth8urbmkp" />
              {row.label}
            </span>
            <span className="shrink-0 font-display text-base font-bold text-navy/60 line-through" data-id="element-199" data-mp="1flc2gn6j35qh">
              {row.value}
            </span>
          </li>)}
        <li className="flex items-center justify-between gap-4 bg-navy px-4 py-4" data-id="element-200" data-mp="16lytrwq8al6t">
          <span className="text-[13px] font-bold uppercase tracking-[0.14em] text-white/70" data-id="element-201" data-mp="16o1ouv68n4ie">
            Total value
          </span>
          <span className="font-display text-2xl font-bold text-gold line-through" data-id="element-202" data-mp="1za4falp3we7p">
            $592
          </span>
        </li>
      </ul>

      <div className="mt-8 rounded-3xl border-2 border-gold bg-white p-6 text-center shadow-[0_25px_60px_-30px_rgba(10,31,68,0.55)]" data-id="element-203" data-mp="1uhtgjm63qygq">
        <p className="text-[14px] font-semibold text-navy/70" data-id="element-204" data-mp="2mzoyn5p69dhi">
          But today you won't pay $592… or even $297.
        </p>
        <p className="mt-4 text-[12px] font-bold uppercase tracking-[0.16em] text-navy/45" data-id="element-205" data-mp="2i8787bkryvas">
          Immediate access for just
        </p>
        <p className="mt-1 font-display text-[4.5rem] font-bold leading-none text-navy" data-id="element-206" data-mp="317k5fks4ovdj">
          $27
        </p>
        <p className="mt-2 text-[13px] font-semibold text-navy/60" data-id="element-207" data-mp="366epsr5qurzr">
          One payment. No subscription. No monthly fees. Lifetime access.
        </p>

        <p className="mx-auto mt-4 flex max-w-xs items-center justify-center gap-2 rounded-full bg-navy/5 px-3 py-2 text-[12px] font-semibold leading-snug text-navy/70" data-id="element-208" data-mp="2wdfwivzayd9t">
          <GlobeIcon className="h-4 w-4 shrink-0 text-gold-dark" data-id="element-209" data-mp="2neluur746wpe" />
          Currency is converted automatically to your local currency
        </p>

        <div className="mt-6" data-id="element-210" data-mp="29g48oxwuxs9l">
          <CTAButton variant="navy" label="Yes, I want the complete Blueprint" data-id="element-211" data-mp="2dfwi1cu2s2g0" />
        </div>

        <div className="mt-5" data-id="element-212" data-mp="7moexs5h3xae">
          <Countdown data-id="element-213" data-mp="7npti6lp71wv" />
        </div>

        <div className="mt-5" data-id="element-214" data-mp="bo9qna69u5j0">
          <ScarcityBar data-id="element-215" data-mp="bni56s6e1o6g" />
        </div>

        <ul className="mt-5 grid gap-2 text-left sm:grid-cols-2" data-id="element-216" data-mp="bmffgnksxrs4">
          {perks.map(perk => <li key={perk} className="flex items-center gap-2 text-[13.5px] font-semibold text-navy/80" data-id="element-217" data-mp="1w4hnottqiml9">
              <CheckIcon className="h-4 w-4 shrink-0 text-gold-dark" data-id="element-218" data-mp="25wna7o17wbt2" />
              {perk}
            </li>)}
        </ul>

        <p className="mt-5 flex items-center justify-center gap-1.5 text-[12px] font-medium text-navy/50" data-id="element-219" data-mp="2143vgnqsnamo">
          <LockIcon className="h-3.5 w-3.5" data-id="element-220" data-mp="2fsqf31ngeojp" />
          Secure checkout • Encrypted payment
        </p>
      </div>
    </Section>;
}